import { ProductApiModel } from './product-api-model';

export class ProductDetails {
    ProductIDAutoComplete:ProductApiModel;
}
